import { default as WscIconSvg169 } from "./169";
import { default as WscIconSvg45 } from "./45";
import { default as WscIconSvg54 } from "./54";
import { default as WscIconSvg916 } from "./916";
import { default as WscIconSvg78 } from "./78";
import { default as WscIconSvg21 } from "./21";
import { default as WscIconSvg23 } from "./23";
import { default as WscIconSvg34 } from "./34";
import { default as WscIconSvg32 } from "./32";
import { default as WscIconSvg38 } from "./38";
import { default as WscIconSvg51 } from "./51";
import { default as WscIconSquare } from "./Square";
import { default as WscIconHorizontalNoText } from "./HorizontalNoText";
import { default as WscIconVerticalNoText } from "./VerticalNoText";
import { default as WscIconSquareNoText } from "./SquareNoText";
import { default as WscIconFourToFiveNoText } from "./FourToFiveNoText";
import { default as WscSevenToEightNoText } from "./SevenToEightNoText";
import { default as WscTwoToOneNoText } from "./TwoToOneNoText";
import { default as WscTwoToThreeNoText } from "./TwoToThreeNoText";
import { default as WscThreeToFourNoText } from "./ThreeToFourNoText";
import { default as WscSixteenToNineNoText } from "./SixteenToNineNoText";
import { default as WscThreeToTwoNoText } from "./ThreeToTwoNoText";
import { default as WscThreeToEightNoText } from "./ThreeToEightNoText";

const icons = {
  WscIconSvg169,
  WscIconSvg45,
  WscIconSvg54,
  WscIconSvg916,
  WscIconSvg78,
  WscIconSvg21,
  WscIconSvg23,
  WscIconSvg34,
  WscIconSvg32,
  WscIconSvg38,
  WscIconSvg51,
  WscIconSquare,
  WscIconHorizontalNoText,
  WscIconVerticalNoText,
  WscIconSquareNoText,
  WscIconFourToFiveNoText,
  WscSevenToEightNoText,
  WscTwoToOneNoText,
  WscTwoToThreeNoText,
  WscThreeToFourNoText,
  WscSixteenToNineNoText,
  WscThreeToTwoNoText,
  WscThreeToEightNoText,
};

export default icons;
